module.exports = __webpack_public_path__ + "static/7c5ce88a8c4a1e381e9f44f24b58f0e657b8849435e14855e0e25d3db0ebd70b-d64dde70e4fed16fa0a872da1fffb78f.png";